import { cn } from '@PorkyCol/theme';

type Props = {
  timer: string;
  color: string;
  classNames?: {
    time?: string;
    timeContainer?: string;
  };
};
export const Stopwatch = ({ timer, color, classNames }: Props) => (
  <div
    className={cn(
      `w-14 h-14 rounded-full border-4 flex items-center justify-center ${color}`,
      classNames?.timeContainer
    )}
  >
    <span className={cn('text-white text-small font-bold', classNames?.time)}>{timer}</span>
  </div>
);
